import './app/globals.css';
import { isAgentsEmbed } from '@/lib/agents-embed';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import * as Sentry from '@sentry/react';
import { I18nProvider } from '@/i18n/provider';
import { AuthProvider } from '@/contexts/auth-context';
import { FlagsProvider } from '@/contexts/flags-context';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AppRouter } from '@/router';
import { ImpersonationBanner } from '@/components/impersonation-banner';
import '@/i18n/init';
import '@/lib/posthog';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div>An unexpected error occurred. Please refresh the page.</div>}>
      <BrowserRouter basename={isAgentsEmbed() ? '/embed' : undefined}>
        <I18nProvider>
          <AuthProvider>
            <FlagsProvider>
              <TooltipProvider>
                <ImpersonationBanner />
                <AppRouter />
              </TooltipProvider>
            </FlagsProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
